import React from "react";
import { Card, CardContent, Box, Skeleton } from "@mui/material";

const TemplateSkeletonCard = () => {
  return (
    <Card>
      <CardContent>
        <Skeleton variant="text" width="70%" height={30} sx={{ mb: 1 }} />

        {/* Summary skeleton - two lines */}
        <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="85%" height={20} sx={{ mb: 2 }} />

        {/* Piece icons skeleton */}
        <Box sx={{ display: "flex", gap: 0.5, mt: 2 }}>
          <Skeleton variant="rounded" width={20} height={20} />
          <Skeleton variant="rounded" width={20} height={20} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default TemplateSkeletonCard;
